import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';

import { environment } from './../../../../../environments/environment';

@Injectable()
export class ProductCategoryDetailService {
  private urlPrefix: string = environment.appUrl;
  constructor(
    private http: HttpClient
  ) {}

  getDetail(id): Observable<any> {
    const url = this.urlPrefix + 'product-cats/' + id ;
    return this.http
      .get(url, { observe: 'response' })
      .map(
        res => {
          if (res.status === 200) {
            return res.body;
          } else {
            return Observable.throw(null);
          }
        }
      )
      .catch(
        err => {
          return Observable.throw(err);
        }
      );
  }

  // updateProductCatByStatus(status: number): Observable<any> {
  // }
}



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/product-category/detail/detail.service.ts